import {
  Components,
  InputInformation,
  ValidationType,
  Size,
} from '@utahdts/dts-react-common';
import Inputmask from 'inputmask';
import { formatTextFieldValue } from '../../misc/textFieldFormatter';
import wireInputChanges from './wireInputChanges';

export default ({ inputsOnChange }, isNew) => {
  const inputs = {
    ndc: new InputInformation({
      field: 'ndc',
      label: 'National Drug Code:',
      type: Components.TEXT_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
      maskType: {
        inputMask: new Inputmask('99999999999', {
          placeholder: '',
          clearMaskOnLostFocus: false,
          autoUnmask: true,
          onBeforePaste: (value) => {
            const formatted = formatTextFieldValue(value);
            const digits = formatted.supported
              ? formatted.value.match(/\d+/g)
              : null;
            digits && inputsOnChange('ndc', digits.join(''));
          },
        }),
      },
    }),
    // Type and description stay editable when editing an existing drug; only
    // the NDC (the drug's identity) is locked after creation.
    type: new InputInformation({
      field: 'type',
      label: 'Type:',
      type: Components.SELECT_INPUT,
      multiSelect: false,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      options: [
        { value: 'brand', label: 'Brand' },
        { value: 'generic', label: 'Generic' },
      ],
    }),
    description: new InputInformation({
      field: 'description',
      label: 'Description:',
      type: Components.TEXT_AREA,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
    }),
  };

  wireInputChanges(inputs, inputsOnChange);

  return inputs;
};
